import React from 'react'
import injectStyles from 'react-jss'
import styles from '../styles'
import LoadingIndicator from '../../LoadingIndicator/LoadingIndicator'

const DrawMapView = ({
  setCursorPosition,
  controls,
  hideMapControls,
  children,
  loading,
  classes,
}) => {
  return (
    <section
      className={classes.wrapper}
      onClick={e =>
        setCursorPosition(
          {
            left: e.clientX,
            top: e.clientY,
          },
          e.currentTarget.offsetWidth,
        )
      }
    >
      <div />
      {loading && (
        <div className={classes.loadingWrapper}>
          <LoadingIndicator />
        </div>
      )}
      <div className={classes.controlsWrapper}>
        {hideMapControls ? null : controls}
      </div>
      {children}
    </section>
  )
}

export default injectStyles(styles)(DrawMapView)



// WEBPACK FOOTER //
// ./src/Components/DrawMap/component/DrawMapView.js